/** Исходные PDF-документы в `public/docs` (заглушки шаблона). */
export const legalDocumentSources = {
  agreement: 'СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ SKUBY.pdf',
  privacy: 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ SKUBY.pdf',
  offer: 'ПУБЛИЧНАЯ ОФЕРТА SKUBY.pdf',
  returns: 'Политика возвратов товара интернет-магазина Skuby.pdf',
  dataTransfer: 'Согласие на передачу персональных данных третьим лицам.pdf',
} as const

export type LegalDocumentSourceKey = keyof typeof legalDocumentSources

export function getLegalDocumentSourceUrl(key: LegalDocumentSourceKey): string {
  const filename = legalDocumentSources[key]
  return `/docs/${encodeURIComponent(filename)}`
}
